module.exports = __webpack_public_path__ + "static/media/citation_one.47612b42.glb";